import * as yup from 'yup';

import { http } from 'lib/services/http';
import { iamOrchestrationBaseUrl } from 'constants/apiUrls';

// IAMOS Swagger -- http://10.103.51.75:8080/swagger-ui.html#/Teams
const PROFILE_MANAGERS_API_PATH = `${iamOrchestrationBaseUrl}`;

const teamObjectValidator = yup.object().shape({
  addedProfileIds: yup.array().of(yup.string()).optional(),
  droppedProfileIds: yup.array().of(yup.string()).optional(),
  name: yup.string().required(),
  voiceEnabled: yup.boolean().optional(),
});

export const getManagersInfo = () => {
  return http.get(
    `${PROFILE_MANAGERS_API_PATH}/users/admins/profiles?onlyActiveAdmins=true`,
  );
};

export const getUsersBasicInfo = () => {
  return http.get(`${iamOrchestrationBaseUrl}/users/basic-info`);
};

export const getTeams = () => {
  return http.get(`${iamOrchestrationBaseUrl}/teams`);
};

export const getTeamInfo = (teamName = '') => {
  return http.get(`${iamOrchestrationBaseUrl}/teams/team/${teamName}`);
};

export const createTeam = (teamObj = {}) => {
  return teamObjectValidator.validate(teamObj).then(() => {
    return http.post(`${iamOrchestrationBaseUrl}/teams/team`, teamObj);
  });
};

export const updateTeamInfo = (teamName = '', teamObj = {}) => {
  return teamObjectValidator.validate(teamObj).then(() => {
    return http.put(
      `${iamOrchestrationBaseUrl}/teams/team/${teamName}`,
      teamObj,
    );
  });
};
